module.exports = __webpack_public_path__ + "static/media/timer-icon.84f8ce13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/promocode/timer-icon.svg
// module id = 1631
// module chunks = 103